export class Salesperson {
  firstName: string;
  lastName: string;
  partnerId: string;
  marketId: string;
  salesPersonId: string;
  email: string;
  phoneNumber: string;
  photoUrl: string;
  jobTitle: string;
  country: string;

  constructor(data: any) {
    Object.assign(this, data);
    if (data.pid) {
      this.partnerId = data.pid;
    }
    if (data.photoUrl && data.photoUrlSecure) {
      this.photoUrl = data.photoUrlSecure;
    }
  }

  get contactNumber(): string {
    if (this.phoneNumber.length > 0) {
      return this.phoneNumber[0];
    }
    return '';
  }

  get name(): string {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  get photo(): string {
    return this.photoUrl || '/static/images/Profile.svg';
  }

  static fromSalesPersonVObject(vobject: any): Salesperson {
    return new Salesperson({
      firstName: vobject.first_name,
      lastName: vobject.last_name,
      partnerId: vobject.partner_id,
      marketId: vobject.market_id,
      salesPersonId: vobject.salesperson_id || vobject.sales_person_id,
      email: vobject.email,
      phoneNumber: vobject.phone_number,
      photoUrl: vobject.picture_serving_url,
      jobTitle: vobject.jobTitle,
      country: vobject.country,
    });
  }
}
